(function () {
  "use strict";

  class AkimuSlider {
    constructor(root) {
      if (!root) return;

      // 二重初期化防止
      if (root.__akimuInitialized) return;
      root.__akimuInitialized = true;

      this.root = root;
      this.viewport = root.querySelector("[data-akimu-viewport]");
      this.track = root.querySelector("[data-akimu-track]");
      this.slides = root.querySelectorAll("[data-akimu-slide]");

      if (!this.viewport || !this.track || this.slides.length === 0) return;

      this.autoplayEnabled = root.dataset.autoplay === "true";
      this.autoplayMs = parseInt(root.dataset.autoplayMs || "4000", 10);
      this.resumeMs = parseInt(root.dataset.resumeMs || "5000", 10);

      this.timer = null;
      this.resumeTimer = null;

      this.isDragging = false;
      this.startX = 0;
      this.startScroll = 0;
      this.hasMoved = false;

      this.init();
    }

    init() {
      this.bindEvents();
      this.startAutoplay();
    }

    bindEvents() {
      // Pointer events（PCドラッグ + スマホはネイティブ）
      this.viewport.addEventListener("pointerdown", this.onPointerDown.bind(this));
      window.addEventListener("pointermove", this.onPointerMove.bind(this));
      window.addEventListener("pointerup", this.onPointerUp.bind(this));

      this.viewport.addEventListener("scroll", this.onScroll.bind(this), { passive: true });

      window.addEventListener("resize", this.snapToNearest.bind(this));

      // Shopifyテーマエディタ再読込対応
      document.addEventListener("shopify:section:unload", () => {
        this.destroy();
      });
    }

    destroy() {
      this.stopAutoplay();
      clearTimeout(this.resumeTimer);
    }

    getSlideWidth() {
      const first = this.slides[0];
      if (!first) return 1;
      return first.offsetWidth;
    }

    getCurrentIndex() {
      const width = this.getSlideWidth();
      return Math.round(this.viewport.scrollLeft / width);
    }

    scrollToIndex(index) {
      const width = this.getSlideWidth();
      const max = this.slides.length - 1;
      const target = Math.max(0, Math.min(index, max));
      this.viewport.scrollTo({
        left: target * width,
        behavior: "smooth"
      });
    }

    next() {
      const current = this.getCurrentIndex();
      const last = this.slides.length - 1;

      if (current >= last) {
        this.scrollToIndex(0); // ループ
      } else {
        this.scrollToIndex(current + 1);
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.next(), this.autoplayMs);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    pauseAndResume() {
      if (!this.autoplayEnabled) return;

      this.stopAutoplay();
      clearTimeout(this.resumeTimer);

      this.resumeTimer = setTimeout(() => {
        this.startAutoplay();
      }, this.resumeMs);
    }

    onPointerDown(e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      this.isDragging = true;
      this.hasMoved = false;
      this.startX = e.clientX;
      this.startScroll = this.viewport.scrollLeft;

      this.pauseAndResume();
    }

    onPointerMove(e) {
      if (!this.isDragging) return;

      const dx = e.clientX - this.startX;

      if (Math.abs(dx) > 5) {
        this.hasMoved = true;
      }

      if (e.pointerType === "mouse" && this.hasMoved) {
        e.preventDefault();
        this.viewport.scrollLeft = this.startScroll - dx;
      }
    }

    onPointerUp() {
      if (!this.isDragging) return;

      this.isDragging = false;

      if (this.hasMoved) {
        this.snapToNearest();
      }

      setTimeout(() => {
        this.hasMoved = false;
      }, 50);
    }

    onScroll() {
      this.pauseAndResume();
    }

    snapToNearest() {
      const index = this.getCurrentIndex();
      this.scrollToIndex(index);
    }
  }

  function initSliders() {
    document.querySelectorAll("[data-akimu-slider]").forEach((el) => {
      new AkimuSlider(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSliders);
  } else {
    initSliders();
  }

  document.addEventListener("shopify:section:load", initSliders);
})();